import React from "react";


const BackToTop = () => {
    return (
        <a href="#" className="back-to-top d-flex align-items-center justify-content-center"><i className="bi bi-arrow-up-short"></i></a>
    );
}

export default BackToTop;